(function () {
  angular.module("akitabox.ui.dialogs.floor.create", [
    "ngMaterial",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.services.floor",
    "akitabox.core.services.flag",
  ]);
})();
